import { DraftUI } from "@corpuscomplete/core-ui/common/draft";
import type { Draft } from "@corpuscomplete/core/common/draft";
import type { ZodType } from "zod/v4";
import { useAuth } from "../auth/hooks";

export function useDraft<T extends Draft.Info["data"]>(
  type: string,
  schema: ZodType<T>,
  defaultValue: () => T,
) {
  const { userId } = useAuth();
  return DraftUI.useDraft(userId, type, schema, defaultValue);
}
